import { render, staticRenderFns } from "./SoftLogo.vue?vue&type=template&id=055aeb38&"
import script from "./SoftLogo.vue?vue&type=script&lang=js&"
export * from "./SoftLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports